import PetOrderAPI from '@/app/apis/main/pet-order/pet-order-api';

export default {
	/**
	* @params {Object} purchaseDetails
	* */
	async getPetPurchase(purchaseDetails) {
		return PetOrderAPI.getPetPurchase(purchaseDetails);
	},

	/**
	* @params {Object} purchaseDetails
	* @params {id} orderId
	* */
	async putPetPurchase(purchaseDetails,orderId) {
		return PetOrderAPI.putPetPurchase(purchaseDetails,orderId);
	},

	/**
	* @params {id} orderId
	* */
	async getPetPurchaseByOrderId(orderId) {
		return PetOrderAPI.getPetPurchaseByOrderId(orderId);
	},
	/**
	* @params none
	* */
	async getPetOrderCount() {
		return PetOrderAPI.getPetOrderCount();
	},

	/**
	 * @params {Object} purchaseDetails
	 * */
	 async getDogPurchase(referenceId) {
		return PetOrderAPI.getDogPurchase(referenceId);
	},

	/**
	 * @params {Object} details
	 * */
	 async dogPurchaseApprovedDisapproved(details) {
		return PetOrderAPI.dogPurchaseApprovedDisapproved(details);
	},

	/**
	 * @params {Object} details
	 * */
	 async updateDogPurchaseDetails(details,referenceId) {
		return PetOrderAPI.updateDogPurchaseDetails(details,referenceId);
	},

	/**
	 * @params {Object} requestDetails
	 * */
	 async dogPurchaseApprovedDisapprovedRefund(requestDetails) {
		return PetOrderAPI.dogPurchaseApprovedDisapprovedRefund(requestDetails);
	},

	/**
	 * @params {Object} requestDetails
	 * */
	async dogPurchaseApprovedRefund(requestDetails) {
		return PetOrderAPI.dogPurchaseApprovedRefund(requestDetails);
	},

	async dogPurchaseApprovedDisapprovedBreed(requestDetails) {
		return PetOrderAPI.dogPurchaseApprovedDisapprovedBreed(requestDetails);
	},
}